module.exports = __webpack_public_path__ + "fonts/Calibre-LightItalic.1222cf0d.woff";